import cs from 'classnames';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Loader from 'components/shared/Loader/Loader';

const OptionContent = ({
  option,
  label,
  isHovered,
  optionIconSize,
  optionIconColor,
  optionIconNoColor,
  iconsShade
}) => {
  if (!option.loading && !option.icon && !label) return null;

  return (
    <div className={cs('flex grow items-center gap-x-2', option.className)}>
      {/* Icon or loader */}
      {option.loading ? (
        <Loader
          outlined
          className={`text-${optionIconColor}-500`}
          type={isHovered ? 'secondary' : 'primary'}
        />
      ) : typeof option.icon === 'object' ? (
        option.icon
      ) : (
        option.icon && (
          <Icon
            icon={option.icon}
            size={optionIconSize}
            customColor={option.customColor}
            color={option.color || optionIconColor}
            disableColor={optionIconNoColor}
            shade={iconsShade}
            stroke={option.stroke}
          />
        )
      )}
      {/* Label */}
      {typeof option.label === 'object' ? (
        option.label
      ) : (
        <span
          className={cn(
            'grow select-none whitespace-nowrap text-sm font-400',
            option.textClassName,
            option.color === 'primary' || optionIconColor === 'primary'
              ? 'text-primary-900'
              : 'text-neutral-900'
          )}>
          {label}
        </span>
      )}

      {option.rightLabel && (
        <span className="shrink-0 select-none whitespace-nowrap pl-6 text-sm font-400 text-neutral-600">
          {option.rightLabel}
        </span>
      )}

      {/* Right icon */}
      {typeof option.rightIcon === 'object'
        ? option.rightIcon
        : option.rightIcon && (
            <Icon
              icon={option.rightIcon}
              size={optionIconSize}
              color={option.color || optionIconColor}
              disableColor={optionIconNoColor}
              shade={iconsShade}
              stroke={option.stroke}
            />
          )}
    </div>
  );
};

export default OptionContent;
